import React, { useState } from 'react';
import { Button } from '@mantine/core';
import { DeliveryManifest } from '@/pages/Event.page/types';
import { useApolloClient } from '@apollo/client';

type DeliveryManifestDownloadProps = {
  item: DeliveryManifest;
  preview?: boolean;
};

const DeliveryManifestDownload: React.FC<DeliveryManifestDownloadProps> = ({ item, preview }) => {
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();
  if (!item?.documentUrl || item.status === 'Confirmed') {
    return null;
  }
  const confirmManifest = async (item: DeliveryManifest) => {
    if (!item?.confirmationUrl) {
      return;
    }
    setLoading(true);

    try {
      await fetch(new URL(item.confirmationUrl, import.meta.env.VITE_MY_FOODA_APP_URL).href, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          preview: !!preview,
          token: item.confirmationToken,
        }),
      });

      await client.refetchQueries({
        include: 'active',
      });
    } catch (error) {
      console.error('Error confirming manifest:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button onClick={() => confirmManifest(item)} loading={loading} variant="outline" ml="auto">
      Confirm
    </Button>
  );
};

export default DeliveryManifestDownload;
